/**
 * Whether debug mode is enabled
 */
let debugEnabled = false;

/**
 * Log a debug message if debug mode is enabled
 * @param message The message to log
 * @param args Additional arguments to log
 */
export function debug(message: string, ...args: unknown[]): void {
  if (debugEnabled && typeof console !== "undefined") {
    console.log(`[FairShare]`, message, ...args);
  }
}

/**
 * Set debug mode
 * @param enabled Whether debug mode is enabled
 */
export function setDebugMode(enabled: boolean): void {
  debugEnabled = enabled;
}

/**
 * Get current debug mode state
 * @returns Whether debug mode is enabled
 */
export function isDebugMode(): boolean {
  return debugEnabled;
}
